import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const DashboardPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "DashboardPage" */ './Container'),
  'page'
);
